import useAppIsFramed from './useAppIsFramed';
export * from './useAppIsFramed';
export default useAppIsFramed;
